export default function FeaturesSection() {
  const features = [
    {
      icon: 'ri-refresh-line',
      title: 'Updated Daily',
      description: 'Our AllChinaBuy spreadsheet is refreshed every day with the latest finds, ensuring you never miss a trending product or reliable seller.',
      imageUrl: 'https://readdy.ai/api/search-image?query=Open%20laptop%20displaying%20colorful%20spreadsheet%20interface%20on%20white%20desk%20with%20coffee%20cup%20and%20notebook%2C%20morning%20sunlight%20streaming%20through%20window%2C%20organized%20productive%20workspace%2C%20fresh%20clean%20aesthetic%2C%20soft%20natural%20lighting%2C%20modern%20home%20office%20with%20potted%20plant%2C%20editorial%20lifestyle%20photography%20with%20warm%20and%20inviting%20atmosphere&width=400&height=280&seq=feature-v2-daily-z20&orientation=landscape',
    },
    {
      icon: 'ri-shield-check-line',
      title: 'QC Verified',
      description: 'Every product listing includes quality control notes so you can shop with confidence and avoid unreliable items.',
      imageUrl: 'https://readdy.ai/api/search-image?query=Magnifying%20glass%20inspecting%20fabric%20quality%20on%20beige%20linen%20surface%2C%20fashion%20quality%20control%20concept%2C%20soft%20natural%20daylight%2C%20clean%20minimalist%20composition%2C%20warm%20neutral%20tones%2C%20editorial%20product%20photography%2C%20detailed%20texture%20inspection%20with%20gentle%20shadows%2C%20professional%20craftsmanship%20aesthetic&width=400&height=280&seq=feature-v2-qc-z21&orientation=landscape',
    },
    {
      icon: 'ri-scales-line',
      title: 'Price Comparison',
      description: 'Compare prices across multiple trusted sellers at a glance — save money while getting the best quality available.',
      imageUrl: 'https://readdy.ai/api/search-image?query=Two%20stylish%20sneakers%20side%20by%20side%20with%20price%20tags%20on%20minimal%20white%20surface%2C%20comparison%20shopping%20concept%2C%20soft%20studio%20lighting%2C%20clean%20editorial%20photography%2C%20neutral%20warm%20background%2C%20subtle%20shadows%2C%20elegant%20product%20presentation%2C%20consumer%20decision%20making%20visual%20metaphor&width=400&height=280&seq=feature-v2-price-z22&orientation=landscape',
    },
    {
      icon: 'ri-guide-line',
      title: 'Buying Guides',
      description: 'Step-by-step tutorials help beginners navigate the AllChinaBuy spreadsheet, from finding products to safe shipping methods.',
      imageUrl: 'https://readdy.ai/api/search-image?query=Open%20fashion%20lookbook%20and%20tablet%20displaying%20shopping%20guide%20on%20cream%20linen%20surface%20with%20accessories%20scattered%20around%2C%20warm%20afternoon%20light%2C%20cozy%20creative%20workspace%2C%20editorial%20lifestyle%20photography%2C%20soft%20neutral%20palette%2C%20organized%20yet%20inviting%20composition%2C%20modern%20educational%20content%20aesthetic&width=400&height=280&seq=feature-v2-guide-z23&orientation=landscape',
    },
  ];

  return (
    <section className="py-16 md:py-24 bg-background-100">
      <div className="px-4 md:px-6 max-w-7xl mx-auto">
        <div className="text-center mb-12 md:mb-16">
          <span className="inline-block px-4 py-1.5 text-xs font-semibold text-primary-700 bg-primary-100 rounded-full mb-4">
            Why Choose Us
          </span>
          <h2 className="font-heading text-3xl md:text-4xl font-bold text-foreground-900 mb-4">
            Why Thousands of Users Trust Our<br />AllChinaBuy Spreadsheet
          </h2>
          <p className="text-foreground-600 max-w-2xl mx-auto text-sm md:text-base">
            Finding trusted products online can be difficult. Our spreadsheet helps you discover quality items, compare sellers, and buy with confidence.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 md:gap-8">
          {features.map((feat) => (
            <div
              key={feat.title}
              className="group bg-background-50 rounded-2xl overflow-hidden hover:bg-primary-50/50 transition-colors duration-300 cursor-default"
            >
              <div className="h-40 md:h-48 overflow-hidden">
                <img
                  src={feat.imageUrl}
                  alt={`AllChinaBuy Spreadsheet - ${feat.title}`}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
              </div>
              <div className="p-5 md:p-6">
                <div className="w-10 h-10 flex items-center justify-center bg-primary-100 rounded-xl mb-4 group-hover:bg-primary-200 transition-colors">
                  <i className={`${feat.icon} text-lg text-primary-600`}></i>
                </div>
                <h3 className="font-heading text-lg font-semibold text-foreground-900 mb-2">{feat.title}</h3>
                <p className="text-sm text-foreground-600 leading-relaxed">{feat.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}